import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.93934 7.06066C4.35355 6.47487 4.35355 5.52513 4.93934 4.93934C5.52513 4.35355 6.47487 4.35355 7.06066 4.93934L12 9.87868L16.9393 4.93934C17.5251 4.35355 18.4749 4.35355 19.0607 4.93934C19.6464 5.52513 19.6464 6.47487 19.0607 7.06066L14.1213 12L19.0607 16.9393C19.6464 17.5251 19.6464 18.4749 19.0607 19.0607C18.4749 19.6464 17.5251 19.6464 16.9393 19.0607L12 14.1213L7.06066 19.0607C6.47487 19.6464 5.52513 19.6464 4.93934 19.0607C4.35355 18.4749 4.35355 17.5251 4.93934 16.9393L9.87868 12L4.93934 7.06066Z",
		fill: "currentColor"
	})
});
const SvgCloseX = styled(base)({});
export default SvgCloseX;
